import type { Notification } from "@/types/dealTask";

import {
  formatDealUpdateMessage,
  type DealUpdatePayload,
} from "./dealUpdateToast";

let localNotificationId = 0;

export function buildDealUpdateNotification(
  data: DealUpdatePayload,
): Notification {
  localNotificationId -= 1;

  return {
    id: localNotificationId,
    user_id: 0,
    type: "deal_updated",
    entity_type: "deal",
    entity_id: data.deal_id,
    title: "Deal updated",
    message: `${data.deal_name} — ${formatDealUpdateMessage(data)}`,
    payload: {
      deal_id: data.deal_id,
      deal_name: data.deal_name,
    },
    read_at: null,
    created_at: new Date().toISOString(),
    is_read: false,
  };
}
